import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import TransactionReportBatched from "@/app/(authenticated)/$merchantId/transactions/_components/transaction-report-batched.tsx";
import { EKeyApiTransaction } from "@/app/(authenticated)/$merchantId/transactions/_data/transaction-report-constant.ts";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/transactions/batch/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const merchantId = Route.useParams().merchantId;

  return (
    <ContainerInset
      title="Transactions"
      breadcrumbs={[
        {
          title: "Current Batch",
          href: `/${merchantId}/transactions?tab=${EKeyApiTransaction.BATCH}`,
        },
        {
          title: `Transactions Batch Report`,
          href: "#",
        },
      ]}
    >
      <TransactionReportBatched />
    </ContainerInset>
  );
}
